import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4250" />
      <ArchitectureDiagram data-id="element-4251" />
      <HowItWorksConnections mode="how" data-id="element-4252" />
      <LivesInSlack data-id="element-4253" />
      <ComputerUse data-id="element-4254" />
      <CapabilityGrid data-id="element-4255" />
      <NarrativeSection data-id="element-4256" />
      <ToolComparison data-id="element-4257" />
      <WallOfLove data-id="element-4258" />
      <PricingSection data-id="element-4259" />
      <ClosingCTA data-id="element-4260" />
    </>;
}